module.exports = __webpack_public_path__ + "img/tile-type-desktop_jp.2e8df6a.jpg";